import type { PurchaseRecommendation } from "../../services/api";

type Props = {
  rows: PurchaseRecommendation[];
};

const URGENCY_LABEL: Record<PurchaseRecommendation["urgency"], string> = {
  ZAM_TERAZ: "ZAM TERAZ",
  ZAM_TYDZIEN: "TEN TYDZIEŃ",
  OK: "OK",
};

const URGENCY_COLOR: Record<PurchaseRecommendation["urgency"], string> = {
  ZAM_TERAZ: "var(--color-danger, #c53030)",
  ZAM_TYDZIEN: "var(--color-accent, #c05621)",
  OK: "var(--color-muted, #718096)",
};

export default function PurchaseRecommendationsTable({ rows }: Props) {
  if (rows.length === 0) {
    return null;
  }
  return (
    <section className="card">
      <h2 className="card__title">📦 Co zamawiać?</h2>
      <table className="data-table">
        <thead>
          <tr>
            <th>Pilność</th>
            <th>SKU</th>
            <th>Nazwa</th>
            <th>Sprzedaż dzienna</th>
            <th>Sugest. zamówienie (7 dni)</th>
            <th>Powód</th>
          </tr>
        </thead>
        <tbody>
          {rows.map((r) => (
            <tr key={r.sku}>
              <td>
                <span
                  style={{
                    display: "inline-block",
                    padding: "0.2rem 0.55rem",
                    borderRadius: 4,
                    fontSize: "0.78rem",
                    fontWeight: 700,
                    color: "#fff",
                    background: URGENCY_COLOR[r.urgency],
                  }}
                >
                  {URGENCY_LABEL[r.urgency]}
                </span>
              </td>
              <td>{r.sku}</td>
              <td>{r.name}</td>
              <td>{r.daily_velocity ? `${Number(r.daily_velocity).toFixed(2)} szt.` : "—"}</td>
              <td>{r.qty_suggested_7d ? `${Number(r.qty_suggested_7d).toFixed(0)} szt.` : "—"}</td>
              <td style={{ fontSize: "0.88rem", opacity: 0.9 }}>{r.reason_pl}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
